import { render, staticRenderFns } from "./MatchOverview.vue?vue&type=template&id=0c5f18ae"
import script from "./MatchOverview.vue?vue&type=script&lang=js"
export * from "./MatchOverview.vue?vue&type=script&lang=js"
import style0 from "./MatchOverview.vue?vue&type=style&index=0&id=0c5f18ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports